import React from "react";
import { Link } from "react-router-dom";
import Shared from "../../../components/ReUseAbleComponents/Shared";

function SingleDocumentation(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-4">
              <div className="dx-sticky dx-sidebar">
                <div className="dx-box dx-box-decorated">
                  <ul
                    className="dx-list dx-list-documentation accordion dx-accordion"
                    id="accordionList"
                  >
                    <li>
                      <Link className="active" to="/single-documentation">
                        Getting Started
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-documentation">Files Structure</Link>
                    </li>
                    <li>
                      <Link to="/single-documentation">Template Structure</Link>
                      <button
                        className="collapsed dx-accordion-btn"
                        type="button"
                      >
                        <span className="icon pe-7s-angle-right"></span>
                      </button>
                      <div
                        id="collapseOne"
                        className="collapse dx-collapse"
                        data-parent="#accordionList"
                      >
                        <ul className="dx-list dx-list-documentation">
                          <li>
                            <Link to="/single-documentation">
                              Main Navigation
                            </Link>
                          </li>
                          <li>
                            <Link to="/single-documentation">
                              Mobile Navigation
                            </Link>
                          </li>
                          <li>
                            <Link to="/single-documentation">Header</Link>
                          </li>
                          <li>
                            <Link to="/single-documentation">Footer</Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <Link to="/single-documentation">Widgets</Link>
                      <button
                        className="collapsed dx-accordion-btn"
                        type="button"
                      >
                        <span className="icon pe-7s-angle-right"></span>
                      </button>
                      <div
                        id="collapseTwo"
                        className="collapse dx-collapse"
                        data-parent="#accordionList"
                      >
                        <ul className="dx-list dx-list-documentation">
                          <li>
                            <Link to="/single-documentation">Plugins</Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <Link to="/single-documentation">Thank You!</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-blog-post">
                  <div className="dx-blog-post-box pt-40 pb-40">
                    <h2 className="h4 mb-0">Getting Started</h2>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-blog-post-box">
                    <p>
                      Kind said evening make. Divide good third saying. Subdue
                      darkness created fill moveth bring green yielding rule,
                      whose called Morning beginning was. It our years sea place
                      fly saw yielding.
                    </p>
                    <p>
                      Divided man that gathered greater she'd fly two very.
                      Third sea that Had sixth won't they're lesser i give
                      wherein there, green shall behold moving moveth rule
                      itself saying so.
                    </p>
                    <p className="mb-50">
                      <code>assets/css/example.css</code> – Tree you'll life
                      abundantly dry thing divide air were beginning.
                    </p>
                    <h3 className="h5">Commented Code</h3>
                    <p>
                      Herb day fifth moved likeness living image. Fourth void
                      male from saw fly Fill so had thing us good you –{" "}
                      <code>assets/js/example.js</code>
                    </p>
                    <code
                      className="dx-gist"
                      data-gist-id="a00300c1a3a9c2b66fc09e3c4083c62f"
                      data-gist-file="contact-form"
                    ></code>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <ul className="dx-blog-post-info mnt-15 mnb-2">
                      <li>Date: 11 Feb 2018</li>
                      <li>Views: 163</li>
                    </ul>
                    <ul className="dx-social-links dx-social-links-style-2 mt-20">
                      <li>
                        <Link to="/#" className="dx-social-twitter">
                          <span className="icon fab fa-twitter"></span> Twitter
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-facebook">
                          <span className="icon fab fa-facebook"></span>{" "}
                          Facebook
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-google">
                          <span className="icon fab fa-google"></span> Google
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-pinterest">
                          <span className="icon fab fa-pinterest"></span>{" "}
                          Pinterest
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="dx-box dx-box-content dx-box-decorated mt-40">
                <div className="row vertical-gap align-items-center justify-content-center">
                  <div className="col-auto">
                    <h3 className="h5 mnt-6 mnb-6">Was this helpful to you?</h3>
                  </div>
                  <div className="col-auto d-flex">
                    <Link to="/#" className="dx-btn dx-btn-md dx-btn-main-1">
                      Yes
                    </Link>
                    <Link
                      to="/#"
                      className="dx-btn dx-btn-md dx-btn-grey-2 ml-20"
                    >
                      No
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleDocumentation;
